/* import __COLOCATED_TEMPLATE__ from './reply-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();